<form [formGroup]="form" class="flex flex-col">
    <section class="w-full lg:w-9/12 xl:w-6/12">
        <app-application-form-field
            label="Notes"
            [ellipsisLength]="messages.comments.length"
            [tooltipMessage]="messages.comments"
            [showTooltipIcon]="false"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Notes</mat-label>
                <textarea
                    #commentBox
                    formControlName="comments"
                    title="Notes"
                    matInput
                    maxlength="1000"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    class="!h-40 !resize-none"
                ></textarea>
            </mat-form-field>
        </app-application-form-field>
    </section>
    <section class="w-full lg:w-9/12 xl:w-6/12">
        <app-application-form-field
            label="Any Additional Attachments Description"
            [ellipsisLength]="messages.anyAdditionalAttachments.length"
            [tooltipMessage]="messages.anyAdditionalAttachments"
            [showTooltipIcon]="false"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>EWA to Provide Additional Attachments?</mat-label>
                <mat-select formControlName="anyAdditionalAttachments">
                    @for (
                        yesNoOption of yesNoOptions;
                        track yesNoOption.value
                    ) {
                        <mat-option [value]="yesNoOption.value">{{
                            yesNoOption.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    </section>
    @if (showAdditionalAttachmentNotes()) {
        <section class="w-full lg:w-9/12 xl:w-6/12">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Additional Attachment Notes</mat-label>
                <textarea
                    formControlName="additionalAttachmentNotes"
                    title="Additional Attachment Notes"
                    matInput
                    maxlength="1000"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    class="!h-40 !resize-none"
                ></textarea>
            </mat-form-field>
        </section>
    }
    <section class="mt-10">
        <app-attachment-grid [applicationId]="applicationId!">
        </app-attachment-grid>
    </section>
</form>
